import { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import NotificationComponent from "../sections/notification/Notification";

export const ChatContext = createContext();

const ChatProvider = ({ children }) => {
    const [mainsocket, setMainSocket] = useState();
    const [newMessage, setNewMessage] = useState();

    useEffect(() => {
        const socketInstance = io(process.env.REACT_APP_SOCKET_URL);
        socketInstance.on("connect", () => {
            console.log("connected");
            setMainSocket(socketInstance);
        });

        return () => {
            mainsocket?.leave('socketLeave', localStorage.getItem("admin_id"));
            mainsocket?.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!mainsocket) return;

        // Join socket room
        mainsocket.emit('socketJoin', localStorage.getItem("admin_id"));
        mainsocket.on("notifiMessage", (chat) => {
            setNewMessage({
                title: chat?.resData?.title || "",
                body: chat?.resData?.message || "",
                icon: chat?.icon || "/default-icon.png"
            });
        });

        mainsocket.on('reconnect', () => {
            mainsocket.emit('socketJoin', localStorage.getItem("admin_id"));
        });

        return () => {
            mainsocket.off("notifiMessage");
        };
    }, [mainsocket]);

    return (
        <ChatContext.Provider value={{ mainsocket }}>
            {children}
            {newMessage && <NotificationComponent data={newMessage} />}
        </ChatContext.Provider>
    );
};

export default ChatProvider;
